/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   trackMultiMessageImpression thunk
 */

import {
  AFFORDABILITY_CALCULATOR_MULTI_MESSAGE_IMPRESSION,
  DETAIL_MULTI_MESSAGE_IMPRESSION,
  DETAIL_MULTI_MESSAGE_SIMILAR_IMPRESSION,
  LIST_ITEM_MULTI_MESSAGE_IMPRESSION,
  PROGRAMMATIC_RENT_MULTI_MESSAGE_IMPRESSION,
} from '@zcode-ui/web-zumper-integrations'
import type { Dispatch } from 'redux'
import type { AdditionalProps } from './trackDetailEvent'
import { type TrackMultiMessageEventProps, trackMultiMessageEvent } from './trackMultiMessageEvent'

export type TrackMultiMessageImpressionProps = Pick<
  TrackMultiMessageEventProps,
  'analyticChannel' | 'entity' | 'origin'
> &
  Pick<AdditionalProps, 'shownPropertyIds'>

export const trackMultiMessageImpression =
  ({ analyticChannel, entity, origin, shownPropertyIds }: TrackMultiMessageImpressionProps) =>
  (dispatch: Dispatch) => {
    const additionalProps = {
      origin,
      shownPropertyIds,
    }

    dispatch(
      trackMultiMessageEvent({
        additionalProps,
        affordabilityCalculatorEvent: AFFORDABILITY_CALCULATOR_MULTI_MESSAGE_IMPRESSION,
        analyticChannel,
        detailEvent: DETAIL_MULTI_MESSAGE_IMPRESSION,
        detailSimilarEvent: DETAIL_MULTI_MESSAGE_SIMILAR_IMPRESSION,
        entity,
        listItemEvent: LIST_ITEM_MULTI_MESSAGE_IMPRESSION,
        origin,
        programmaticRentEvent: PROGRAMMATIC_RENT_MULTI_MESSAGE_IMPRESSION,
      })
    )
  }
